import * as consts from "../consts";
import * as defaults from "../defaults";

function getRequest(url) {
  return new Promise((resolve, reject) => {
    var request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        resolve(request.responseText);
      } else {
        reject(request);
      }
    };
    request.onerror = function () {
      reject(request);
    };
    request.send();
  });
}

function postRequest(url, data) {
  return new Promise((resolve, reject) => {
    let request = new XMLHttpRequest();
    request.open("POST", url, true);
    request.setRequestHeader("Content-Type", "application/json; charset=utf-8");
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        resolve(request.responseText);
      } else {
        reject(request);
      }
    };
    request.onerror = function () {
      reject(request);
    };
    request.send(JSON.stringify(data));
  });
}

function extend(defaults, source) {
  let extendedValues = { ...defaults };
  for (let key in source) {
    if (source.hasOwnProperty(key) && source[key] != null) {
      extendedValues[key] = source[key];
    }
  }
  return extendedValues;
}

export function getAccount() {
  return new Promise((resolve) => {
    let accountID = "";
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute("data-id") === "TisBestSpend") {
        accountID = scripts[i].getAttribute("data-accountid");
        break;
      }
    }
    if (accountID.length > 0) {
      getRequest(consts.SERVICE_URL + "Accounts/" + accountID)
        .then((response) => {
          let account = JSON.parse(response).data;
          account.settings.links = extend(
            defaults.LINKS,
            account.settings.links
          );
          account.settings.images = extend(
            defaults.IMAGES,
            account.settings.images
          );
          account.settings.dictionary = extend(
            defaults.DICTIONARY,
            account.settings.dictionary
          );
          account.settings.validation = extend(
            defaults.VALIDATION,
            account.settings.validation
          );
          resolve(account);
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log("TisBest Spend:");
            console.log(err);
          }
          resolve(null);
        });
    } else {
      resolve(null);
    }
  });
}

export function getCodeDetail(code) {
  return new Promise((resolve, reject) => {
    getRequest(consts.SERVICE_URL + "Donations/" + code, null)
      .then((response) => {
        let donationResponse = JSON.parse(response);
        resolve(donationResponse);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function getSpendDetail(code) {
  return new Promise((resolve, reject) => {
    getRequest(consts.SERVICE_URL + "Donations/" + code + "/spendDetails", null)
      .then((response) => {
        let spendResponse = JSON.parse(response);
        resolve(spendResponse);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function isCodeValid(code) {
  return new Promise((resolve, reject) => {
    getRequest(consts.SERVICE_URL + "Donations/check/" + code, null)
      .then((response) => {
        let valid = JSON.parse(response);
        resolve(valid);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function getCategories() {
  return new Promise((resolve, reject) => {
    getRequest(consts.SERVICE_URL + "Categories/")
      .then((response) => {
        let categories = JSON.parse(response);
        resolve(categories);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function getFeaturedCharities(categoryID) {
  return new Promise((resolve, reject) => {
    getRequest(consts.SERVICE_URL + "Charities/" + categoryID + "/featured")
      .then((response) => {
        let featuredCharities = JSON.parse(response);
        resolve(featuredCharities);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function getNationalCharities(filter) {
  return new Promise((resolve, reject) => {
    let data = {
      categoryColumnName: filter.columnName,
      postalCode: filter.postalCode,
      query: filter.query,
      continuationToken: filter.continuationToken,
    };
    postRequest(consts.SERVICE_URL + "Charities/", data)
      .then((response) => {
        let nationalCharities = JSON.parse(response);
        resolve(nationalCharities);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(err);
      });
  });
}

export function setDonation(
  cardCode,
  name,
  email,
  optIn,
  notifyEmail,
  selectedCharities,
  thankYouName,
  thankYouNote,
  instructions
) {
  return new Promise((resolve, reject) => {
    let charities = selectedCharities.slice();
    let spendDetails = [];
    charities.map((charity) => {
      spendDetails.push({
        ein: charity.ein,
        amount: charity.amount + charity.cents,
        optIn: optIn,
        name: optIn ? name : null,
        email: optIn ? notifyEmail : null,
      });
    });
    postRequest(consts.SERVICE_URL + "Donations/", {
      cardCode: cardCode,
      email: email,
      thankYouName: thankYouName,
      thankYouNote: thankYouNote,
      charitySpendDetails: spendDetails,
      instructions: instructions,
    })
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend:");
          console.log(err);
        }
        reject(null);
      });
  });
}

export function validateName(name) {
  if (name && name.length > 0) {
    return true;
  } else {
    return false;
  }
}

export function validateCode(code) {
  let codeValidation = /^[A-Z0-9]{3}-[A-Z0-9]{3}$/;
  if (codeValidation.test(code)) {
    return true;
  } else {
    return false;
  }
}

export function validateEmail(email) {
  let emailValidation =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailValidation.test(email)) {
    return true;
  } else {
    return false;
  }
}

export function validateThankYouName(thankYouName) {
  if (thankYouName && thankYouName.length > 0) {
    return true;
  } else {
    return false;
  }
}

export function validateThankYouNote(thankYouNote) {
  if (thankYouNote && thankYouNote.length > 0) {
    return true;
  } else {
    return false;
  }
}
